import { format } from "date-fns";
import { isEmpty } from "lodash";

import { IEmployeeAbsences } from "src/Pages/Company/Absences/AbsenceRequest/AbsenceRequest.models";
import { PresenceType } from "src/Pages/Company/Absences/AbsenceType/AbsenceType.models";
import generateDateRange from "./generateDateRange";

/**
 * Validates whether a date range chosen on absence request form overlaps with existing employee absences.
 * Both overlapping absences has to be of type 'ABSENCE'.
 *
 * @param absencesData - The employee's previous absences requests.
 * @param date - A single date from hourly absence request.
 * @param dates - A tuple containing start and end dates from daily absence request.
 * @returns Returns true if there is an overlap with existing absences, false otherwise. Also returns false if no existing absences are found.
 */
export default (
  absencesData: IEmployeeAbsences | undefined,
  date: Date | null,
  dates: [Date | null, Date | null]
) => {
  if (!absencesData?.absences) return false;

  const existingAbsences = absencesData.absences.filter(
    (absence) => absence.presenceType === PresenceType.Absence
  );

  if (isEmpty(existingAbsences)) return false;

  if (date) {
    return existingAbsences.some(
      (absence) => absence.date === format(date, "yyyy-MM-dd")
    );
  }

  if (dates) {
    const dateRange = generateDateRange(dates);

    return existingAbsences.some((absence) => dateRange.includes(absence.date));
  }

  return false;
};
